export function deepCopyObject(originalObject) {
    // technically only goes one level deep
    const newObject = {};
    Object.keys(originalObject).forEach(key => {
        newObject[key] = { ...originalObject[key] }
    });
    return newObject;
}
